import PermissionInterface from '@/utilities/auth/permission/interfaces/PermissionInterface'
import { PermissionRules, ServiceEnum } from '@/utilities/auth/permission/enums/PermissionEnum'
import { UserPermissionType } from '@/utilities/auth/types/UserPermissionType'
import PermissionDecoder from '@/utilities/auth/permission/decoder/PermissionDecoder'
import PermissionDecoderInterface from '@/utilities/auth/permission/decoder/interfaces/PermissionDecoderInterface'

export default class Permission implements PermissionInterface {
  private readonly permissions: UserPermissionType[]

  constructor(permissions: UserPermissionType[]) {
    this.permissions = permissions
  }

  findPermission(serviceName: ServiceEnum): number | null {
    return this.permissions.find(({ service }) => service === serviceName)?.permission ?? null
  }

  permission(serviceName: ServiceEnum): PermissionDecoderInterface {
    return new PermissionDecoder(this.findPermission(serviceName) ?? 0)
  }

  allow(serviceName: ServiceEnum, permissions: PermissionRules[]): boolean {
    const rules = this.permission(serviceName).decode()

    if (!this.findPermission(serviceName)) {
      return false
    }

    return permissions.every(permission => rules[permission])
  }
}
